// AUTO-GENERATED — do not edit by hand.
// Source: packages/shared/src/schema/artifact-types/
// Regenerate: pnpm artifact-types:generate
//
// To add a new artifact type: add a definition under
// packages/shared/src/schema/artifact-types/, run `pnpm artifact-types:generate`,
// register a backend handler if needed, commit. No code changes required.
/**
 * All artifact type keys, sorted alphabetically. Derived from
 * packages/shared/src/schema/artifact-types/.
 */
export const ARTIFACT_TYPES = [
    'attachment',
    'equipment',
    'link',
    'note',
    'protocol',
    'protocol_annotations',
    'protocol_video_binding',
    'spreadsheet',
];
/**
 * Legacy artifact-type enum-style constant for typed string access.
 * Prefer `ArtifactType` (the type union) or destructured `ARTIFACT_TYPE.<NAME>`
 * over string literals throughout the codebase.
 *
 * Generated from packages/shared/src/schema/artifact-types/; to add a new
 * type, add a definition there and regenerate. Keys are the SCREAMING_SNAKE
 * form of the type key.
 */
export const ARTIFACT_TYPE = {
    ATTACHMENT: 'attachment',
    EQUIPMENT: 'equipment',
    LINK: 'link',
    NOTE: 'note',
    PROTOCOL: 'protocol',
    PROTOCOL_ANNOTATIONS: 'protocol_annotations',
    PROTOCOL_VIDEO_BINDING: 'protocol_video_binding',
    SPREADSHEET: 'spreadsheet',
};
/**
 * Capability-driven configuration for every artifact type.
 * Generated from packages/shared/src/schema/artifact-types/.
 */
export const ARTIFACT_TYPE_CONFIG = {
    attachment: {
        displayName: "Attachment",
        icon: "attach_file",
        description: "Uploaded files and documents",
        hasRichTextContent: false,
        hasFileStorage: true,
        generatesEmbeddings: true,
        hasDetailPage: true,
        detailRoutePath: "/attachments/:id",
        canInlineEdit: false,
        validParentTypes: ['workspace', 'project', 'artifact.note', 'artifact.equipment', 'artifact.protocol'],
        agentCanAuthor: false,
    },
    equipment: {
        displayName: "Equipment",
        icon: "biotech",
        description: "Lab instrument or device with knowledge documents",
        hasRichTextContent: false,
        hasFileStorage: false,
        generatesEmbeddings: true,
        hasDetailPage: true,
        detailRoutePath: "/equipment/:id",
        canInlineEdit: false,
        validParentTypes: ['workspace', 'project'],
        attachmentExtraction: "extract-in-place",
        agentCanAuthor: false,
    },
    link: {
        displayName: "Link",
        icon: "link",
        description: "A shortcut to a page outside Bower, opened in a new tab",
        hasRichTextContent: false,
        hasFileStorage: false,
        generatesEmbeddings: false,
        hasDetailPage: true,
        detailRoutePath: "/links/:id",
        canInlineEdit: false,
        validParentTypes: ['workspace', 'project'],
        agentCanAuthor: true,
    },
    note: {
        displayName: "Note",
        icon: "edit_note",
        description: "Text notes with rich formatting",
        hasRichTextContent: true,
        hasFileStorage: false,
        generatesEmbeddings: true,
        hasDetailPage: true,
        detailRoutePath: "/notes/:id",
        canInlineEdit: true,
        validParentTypes: ['workspace', 'project', 'artifact.equipment'],
        mergeable: true,
        agentCanAuthor: true,
    },
    protocol: {
        displayName: "Protocol",
        icon: "science",
        description: "Step-by-step experimental procedures and methods",
        hasRichTextContent: true,
        hasFileStorage: false,
        generatesEmbeddings: true,
        hasDetailPage: true,
        detailRoutePath: "/protocols/:id",
        canInlineEdit: true,
        validParentTypes: ['workspace', 'project'],
        agentCanAuthor: true,
    },
    protocol_annotations: {
        displayName: "Protocol notes",
        icon: "sticky_note_2",
        description: "Lab-learned annotations attached to a protocol",
        hasRichTextContent: true,
        hasFileStorage: false,
        generatesEmbeddings: false,
        hasDetailPage: true,
        detailRoutePath: "/notes/:id",
        canInlineEdit: true,
        validParentTypes: ['artifact.protocol'],
        agentCanAuthor: true,
    },
    protocol_video_binding: {
        displayName: "Protocol video chapters",
        icon: "video_library",
        description: "Reference-video chapter markers aligned to a protocol's steps",
        hasRichTextContent: false,
        hasFileStorage: false,
        generatesEmbeddings: false,
        hasDetailPage: false,
        detailRoutePath: "/notes/:id",
        canInlineEdit: false,
        validParentTypes: ['artifact.protocol'],
        agentCanAuthor: false,
    },
    spreadsheet: {
        displayName: "Spreadsheet",
        icon: "table",
        description: "Workbooks imported from Excel or created in Bower, edited live by you and by agents",
        hasRichTextContent: false,
        hasFileStorage: true,
        generatesEmbeddings: true,
        hasDetailPage: true,
        detailRoutePath: "/spreadsheets/:id",
        canInlineEdit: true,
        validParentTypes: ['workspace', 'project'],
        hasCellData: true,
        agentCanAuthor: false,
    },
};
/**
 * System-internal artifact types — used for storage / linking infrastructure
 * but not user-facing in search, recents, or filter UIs.
 */
export const SYSTEM_INTERNAL_ARTIFACT_TYPES = [
    'protocol_annotations',
    'protocol_video_binding',
];
/**
 * Artifact types that surface in user-facing search, recents, and filter UIs.
 * Excludes SYSTEM_INTERNAL_ARTIFACT_TYPES.
 */
export const USER_FACING_ARTIFACT_TYPES = ARTIFACT_TYPES.filter((t) => !SYSTEM_INTERNAL_ARTIFACT_TYPES.includes(t));
//# sourceMappingURL=artifact-types.generated.js.map